<template>
  <v-container fluid>
    <v-btn
      v-if="!forgot"
      :disabled="!energize"
      :loading="busy"
      @click="forgotPassword"
    >
      forgot password
    </v-btn>

    <v-alert
      v-if="forgot"
      type="info"
    >
      {{ message }}
    </v-alert>
  </v-container>
</template>

<script>
export default {
  props: {
    energize: {
      type: Boolean
    },
    username: {
      type: String,
      default: ()=>null
    }
  },
  data(){
    return {
      busy: false,
      forgot: false,
      message: 'Emailed to ...',
      response: null,
      cache: null
    }
  },
  watch: {
    username(v){
      if (v!=this.cache) {
        this.cache = null
        this.forgot = false
      }
    }
  },
  methods: {
    async forgotPassword(){
      this.busy = true
      this.cache = this.username
      this.response = await this.api.post('/auth/forgot_password/', {
        username: this.username,
        url: window.location.origin
      })
      this.message = `Temporary password reset link was emailed to: ${this.response.email}`
      this.forgot = true
      this.busy = false
    }
  }
}
</script>